import { createGenericListItemReducer } from "common/genericListItemReducer";
import { combineReducers } from "redux";
import { INVOICE_REQUESTED, INVOICE_REQUEST_FAILED, INVOICE_REQUEST_RECEIVED } from "./invoiceActions";

export const invoice = combineReducers({
  invoice: createGenericListItemReducer(INVOICE_REQUESTED, INVOICE_REQUEST_RECEIVED, INVOICE_REQUEST_FAILED)
});
